var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsNoDelivery = function SvgNnIconFlagsNoDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-NO-delivery_svg__Lager_14",
    "data-name": "Lager 14",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-NO-delivery_svg__cls-3{fill:#fff}.nn-icon-flags-NO-delivery_svg__cls-4{fill:#0037a6}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    style: {
      fill: "#ff0015"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.74.25h8.33v33.31h-8.33z",
    className: "nn-icon-flags-NO-delivery_svg__cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.25 12.74h49.97v8.33H.25z",
    className: "nn-icon-flags-NO-delivery_svg__cls-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.82.25h4.16v33.31h-4.16z",
    className: "nn-icon-flags-NO-delivery_svg__cls-4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.25 14.82h49.97v4.16H.25z",
    className: "nn-icon-flags-NO-delivery_svg__cls-4"
  })));
};
export default SvgNnIconFlagsNoDelivery;